export function normalizeItemsFromRes(data: { id: number }[]): {
  [key: number]: { id: number }
} {
  return data.reduce(
    (acc, item, index) => {
      acc[item.asset_type_id] = { ...item, index }
      return acc
    },
    {} as { [key: number]: { id: number } },
  )
}
